<template>
  <Layout></Layout>
</template>

<script>
import Layout from './views/layout';
export default {
  name: 'layout',
  components: {
    Layout: Layout
  }
};
</script>
